import React from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonV3 } from 'components/ComponentV2';

import { API_ROUTES } from 'lib/api-routes';
import { ONBOARDING_FLOW_STATE } from 'lib/consts/flowState';
import { TUserApiResponse } from 'lib/models/User.model';
import { useAuth } from 'lib/providers/AuthProvider';
import { apiInstance } from 'lib/utils/axios';

import Footer from '../Footer';
import Header from '../Header';
import StepHeading from '../StepHeading';
import TouchpointCard, { TouchpointCartDataProps } from '../TouchpointCard';
import styles from './Step1.module.scss';

interface Step1Props {
  progress: number;
  touchpoint: TouchpointCartDataProps[];
  setFlowState: (flowState: string) => void;
}

export const Step1: React.FC<Step1Props> = ({
  progress,
  touchpoint,
  setFlowState,
}) => {
  const { updateUserApiResponse } = useAuth();

  const [t] = useTranslation('onboarding.recruiter');

  const handleOnClick = async () => {
    const flow_state = ONBOARDING_FLOW_STATE.POST_2;
    const recruiter = { flow_state };
    const userResponse = await apiInstance.patch<TUserApiResponse>(
      API_ROUTES.RECRUITER_SIGNUP,
      {
        recruiter,
      }
    );
    updateUserApiResponse(userResponse.data);
  };

  const getCards = () => {
    return touchpoint.map((campaign) => {
      return <TouchpointCard {...campaign} key={campaign.id} />;
    });
  };

  return (
    <>
      <Header
        percentComplete={progress}
        onBack={() => {
          setFlowState(ONBOARDING_FLOW_STATE.PRE_COMPLETE);
        }}
      />
      <div className={styles.stepContent}>
        <StepHeading
          title={t('step-1.header.title')}
          desc={t('step-1.header.desc')}
        />
        {getCards()}
        <Footer>
          <ButtonV3
            type="submit"
            isFullWidth
            size="xlarge"
            onClick={handleOnClick}
          >
            {t('next')}
          </ButtonV3>
        </Footer>
      </div>
    </>
  );
};
